// KWANKGM02040_借入相談結果確認
import React from 'react';
import TopArea from '../../molecules/TopArea';
import Reception from '../../templates/Reception';
import { StepNavigation as StepType } from '../../types/Template';
import { ParentShelf, ChildShelf, Content, GuarantorInfo } from '../../types/Template';
import LoadingModal from '../../molecules/LoadingModal';
import FooterConfirmationBorrowingConsultationResults from '../../organisms/FooterConfirmationBorrowingConsultationResults';

interface Props {
  step_navigation: StepType;
  reception_cd: string;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  looks_inactive: boolean;
  parent_shelfs: ParentShelf[];
  child_shelfs: ChildShelf[];
  contents: Content[];
  setParentShelfs: React.Dispatch<React.SetStateAction<ParentShelf[]>>;
  setChildShelfs: React.Dispatch<React.SetStateAction<ChildShelf[]>>;
  setContents: React.Dispatch<React.SetStateAction<Content[]>>;
  reception_id: number;
  status_code: number;
  is_staff: boolean;
  opened_mypage: boolean;
  moveNextStep: () => void;
  guarantors_num: number;
  is_loading: boolean;
  display_status: boolean;
  show_error_nav: boolean;
  review_approval_status: boolean;
  requestModule: () => void;
  transitionModernizationFundsInputTypeSelect: () => Promise<any>;
  callApi: (function_name: string) => Promise<any>;
  guarantor_info: GuarantorInfo;
  is_agricultural_funds_kinds_agricultural_fund: boolean;
  is_agricultural_funds_kinds_modernization_fund: boolean;
}

const ConfirmationOfBorrowingConsultationResults: React.FC<Props> = ({
  step_navigation,
  reception_cd,
  label,
  status_name,
  display_reception_cd,
  guide_text,
  looks_inactive,
  parent_shelfs,
  child_shelfs,
  contents,
  setParentShelfs,
  setChildShelfs,
  setContents,
  is_staff,
  guarantors_num,
  is_loading,
  display_status,
  show_error_nav,
  review_approval_status,
  requestModule,
  transitionModernizationFundsInputTypeSelect,
  callApi,
  guarantor_info,
  is_agricultural_funds_kinds_agricultural_fund,
  is_agricultural_funds_kinds_modernization_fund,
}) => {
  return (
    <>
      <TopArea
        step_navigation={step_navigation}
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={display_status}
      />
      <Reception
        parent_shelfs={parent_shelfs}
        child_shelfs={child_shelfs}
        contents={contents}
        setParentShelfs={setParentShelfs}
        setChildShelfs={setChildShelfs}
        setContents={setContents}
        looks_inactive={looks_inactive}
        guarantors_num={guarantors_num}
        show_error_nav={show_error_nav}
        callApi={callApi}
        guarantor_info={guarantor_info}
      />
      <FooterConfirmationBorrowingConsultationResults
        is_staff={is_staff}
        review_approval_status={review_approval_status}
        requestModule={requestModule}
        transitionModernizationFundsInputTypeSelect={transitionModernizationFundsInputTypeSelect}
        is_agricultural_funds_kinds_agricultural_fund={
          is_agricultural_funds_kinds_agricultural_fund
        }
        is_agricultural_funds_kinds_modernization_fund={
          is_agricultural_funds_kinds_modernization_fund
        }
      />
      <LoadingModal show={is_loading} />
    </>
  );
};

export default ConfirmationOfBorrowingConsultationResults;
